import { useQuery } from '@tanstack/react-query'
import { committeeApi } from '../lib/api'

/**
 * One node in the committee hierarchy tree returned by `my-hierarchy`. `children` carries the
 * committee's descendants nested to arbitrary depth (WL-5) — the switcher flattens them into
 * indented options via `flattenCommitteeOptions`, which also de-dupes by id and guards cycles.
 */
export interface CommitteeNode {
  id: string
  label: string
  region?: string
  children: CommitteeNode[]
}

export interface CommitteeHierarchy {
  committee: { id: string; label: string; region?: string }
  children: CommitteeNode[]
}

export function useCommitteeHierarchy() {
  return useQuery({
    queryKey: ['committees', 'my-hierarchy'],
    queryFn: async () => {
      const response = await committeeApi.getMyHierarchy()
      return response.data
    },
    staleTime: 5 * 60 * 1000,
  })
}
